import { TextField } from "@shopify/polaris";
import React from "react";

export default function InputField(props) {
  const {
    type,
    label,
    helpText,
    value,
    onChange,
    fieldKey,
    min,
    error,
  } = props;

  return (
    <TextField
      error={error ? error : false}
      min={min}
      type={type}
      label={label}
      helpText={helpText ? helpText : ""}
      value={value}
      onChange={(e) => onChange(fieldKey, e)}
    />
  );
}
